export { default } from '../white-glove-digitization-details';
